import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../styles/offers/all-gym-offers.css";
import HelmetWrapper from "../../../HelmetWrapper";
// import WelcomeUser from "../../Open-pages/user/WelcomeUser";
// import Notifications from "../../push-notifications/Notifications";
import AllGymOffersBanner from "./AllGymOffersBanner";
import AllGymOffersStats from "./AllGymOffersStats";
import AllGymOffersFilter from "./AllGymOffersFilter";
import { useDispatch, useSelector } from "react-redux";
import { fetchOngoingOffersData } from "../../../redux/plans-reducers/plansSlice";
import useDebouncedValue from "../../../hooks/useDebouncedValue.js";

const AllGymOfferStructure = ({ userInfoData, isCustom, isIOS }) => {
  const dispatch = useDispatch();
  const iniAllFilter = {
      search:"",
  }
  const [allFilters, setAllFilters] = useState(iniAllFilter);

  const iniFilters = {
    search: allFilters.search || "",
  };

  const [filters, setFilters] = useState(iniFilters);
  const [searchInput, setSearchInput] = useState(allFilters.search || "");
  const debouncedSearch = useDebouncedValue(searchInput, 500);

  const getAllOffers = (filterParams) => {
    if (userInfoData?.token) {
      dispatch(fetchOngoingOffersData({ 
        filters: filterParams, 
        token: userInfoData.token 
      }));
    }
  };

  useEffect(() => {
    getAllOffers(filters);
  }, [filters, userInfoData?.token]);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      search: debouncedSearch || "",
    }));
  }, [debouncedSearch]);


  return (
    <HelmetWrapper title="WTF: All Gym Offers">
      <Container className="bg-white-color p-0" fluid>
        {/* {isCustom && (
          <Row>
            <Col>
              <div className="mt30">
                <WelcomeUser userName={userInfoData?.name} />

                {userInfoData && !isIOS() && (
                  <Notifications authData={userInfoData} />
                )}
              </div>
            </Col>
          </Row>
        )} */}

        <Row>
          <Col>
            <AllGymOffersBanner
              searchValue={searchInput}
              onSearchChange={setSearchInput}
            />
          </Col>
        </Row>
        
        <Row>
          <Col>
            <AllGymOffersStats />
          </Col>
        </Row>

        <Row>
          <Col>
            <AllGymOffersFilter />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default AllGymOfferStructure;
